module.exports = __webpack_public_path__ + "img/icon-check-green-circular.689d1928.svg";